import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { ApiError, hasLiveApi } from '@/api/client'
import {
  getLoginFromBlockedIps,
  toLoginFromBlockedIpResult,
} from '@/api/map/loginFromBlockedIps'
import type {
  LoginFromBlockedIpQuery,
  LoginFromBlockedIpResult,
} from './loginFromBlockedIpTypes'

/** Empty page when demo / offline — no invented login-from-blocked-IP rows. */
export function emptyLoginFromBlockedIps(
  query: LoginFromBlockedIpQuery = {},
): LoginFromBlockedIpResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
  }
}

/**
 * Live Keycloak → hierarchy `getLoginFromBlockedIps`.
 * Demo / no live API → empty (never invent rows).
 */
export async function loadLoginFromBlockedIps(
  query: LoginFromBlockedIpQuery = {},
): Promise<LoginFromBlockedIpResult> {
  if (!hasLiveApi()) return emptyLoginFromBlockedIps(query)

  try {
    const live = await getLoginFromBlockedIps({
      page: query.page ?? 1,
      pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
      ip: query.ip,
      player: query.player,
    })
    if (!live.value) return emptyLoginFromBlockedIps(query)
    return toLoginFromBlockedIpResult(live, query)
  } catch (err) {
    const status = err instanceof ApiError ? err.status : 0
    console.warn(
      '[login-from-blocked-ip] hierarchy getLoginFromBlockedIps unavailable',
      err,
    )
    if (status === 404) {
      console.warn(
        '[login-from-blocked-ip] Agent-API loginFromBlockedIp/getLoginFromBlockedIps route is not deployed on this hierarchy yet.',
      )
    }
    return emptyLoginFromBlockedIps(query)
  }
}
